import React from 'react';
import { HeaderSkewed } from './styles'

function SkewedBG() {
    return <HeaderSkewed />
}

export default SkewedBG